import React, { useEffect,useRef, useState } from "react"
import { MDBBtn, MDBCard, MDBCardBody, MDBCardText, MDBCardTitle, MDBCol, MDBIcon, MDBInput, MDBRow, MDBSpinner } from "mdb-react-ui-kit";
import { useNavigate } from "react-router";
import { getAccountStreamApiAppsInfo } from "../../apiclients/streamsapi_bridge";
import ApiAppDeletePopup from "../popups/streamsapi/ApiAppDeletePopup";
import CreateStreamsAPIApps from "../popups/streamsapi/CreateStreamsAPIApps";
import { customSearch, useAutoFocusSearchAfterLoads } from "../../components/CustomSearchUtil/CustomSearch";
import UIConstant from "../../apiclients/UIConstant";
import { api_serverUrl } from "../../apiclients/apiurls";
import TabIDConstant from "../../apiclients/TabIDConstant";

function StreamsAPIApps(props) {
    console.log("basicActivebasicActivebasicActive",props.active)
    const [steamsAPIApssInfo, setSteamsAPIApssInfo] = useState([]);
    const [appInfo, setAppInfo] = useState(null);
    const [createAppModal, setCreateAppModal] = useState(false);
    const toggleCreateAppModal = () => setCreateAppModal(!createAppModal);
    const navigate = useNavigate();
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [loading, setLoading] = useState(true);
    const [searchData, setSearchData] = useState();
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
    useAutoFocusSearchAfterLoads(!loading,setDataLoaded, searchRef,props.active);



    const handleSearch = (searchValue) => {
        try {
            setSearchValue(searchValue);
            const filteredRows = customSearch(searchData, searchValue, UIConstant.STREAMS_API_APP_FIELDS)
            setSteamsAPIApssInfo(filteredRows);
        } catch (error) {
            console.log("[handleManualSearch] Error" + error);
        }
    }


    const getAccountStreamApiApps = async () => {
        try {
            const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
            const serverResponse = await getAccountStreamApiAppsInfo(siteid, TabIDConstant.STREAMS_API_APPS_SUBLINK);
            if (!serverResponse.ok) {
                console.log("Network response was not ok");
                throw new Error('Network response was not ok');
            } else {
                const responseData = await serverResponse.json()
                console.log("responseData ::: : " + JSON.stringify(responseData));
                setSteamsAPIApssInfo(responseData?.AppsInfo);
                setSearchData(responseData?.AppsInfo);
                setDataLoaded(true)
            }
        } catch (error) {
            console.log("Error  [getAccountStreamApiApps] " + error);
        } finally {
            // Always hide loader whether success or error
            setDataLoaded(true)
            setTimeout(() => {
                setLoading(false);
            }, 1000)
        }
    }

    const redirectToAppSettings = (data) => {
        navigate("/streamsapisettings", { state: { data } });
    }

    useEffect(() => {
        getAccountStreamApiApps();
    }, []);


    return (
        <React.Fragment>
            <>
                <div className="my-3 d-flex align-items-center justify-content-between">
                    <div className='mb-2 position-relative' style={{ width: "306px" }}>
                        {!loading && (
                            <div className="mb-2 mt-2 position-relative w-auto">
                                <MDBInput
                                    label="Search"
                                     ref={searchRef}
                                    value={searchValue}
                                    onChange={(e) => handleSearch(e.target.value)}
                                />
                                <MDBIcon fas icon="search" className="MDBDatatable-Search" />
                            </div>
                        )}
                    </div>
                    <div className="d-flex align-items-center">
                        <MDBBtn onClick={toggleCreateAppModal}><MDBIcon fas icon="plus" /> Create App</MDBBtn>
                        <a href={`${api_serverUrl}docs/html/Streams_API_Web_Help/index.htm`}
                            target="_blank">
                            <MDBBtn outline className="ms-3">
                                <MDBIcon fas icon="file-alt" />
                                Help Docs</MDBBtn>
                        </a>
                    </div>

                </div>
                {loading ? (
                    <div>
                        <div className="loadingclass-popup"></div>
                        <div className="popup-bg-loader loader_align">
                            <MDBBtn disabled>
                                <MDBSpinner
                                    size="sm"
                                    role="status"
                                    tag="span"
                                    className="me-2"
                                />
                                Loading...
                            </MDBBtn>
                        </div>
                    </div>
                ) : (
                    <MDBRow className="apicards-container">
                        {steamsAPIApssInfo.length > 0 && steamsAPIApssInfo.map((data, index) => (
                            <MDBCol sm={12} md={3} lg={3} xl={3} className="mb-3" key={index} onClick={(event) => {
                                event.stopPropagation(); // Example if you need to prevent bubbling
                                redirectToAppSettings(data)
                            }}>
                                <MDBCard className="shadow-3 border rounded-3 apiCard" style={{ minHeight: "120px" }}>
                                    <MDBCardBody className="px-1 py-3">
                                        <MDBCardTitle className="d-flex align-items-center justify-content-between">
                                            <div className="fw-bold" title={data.appname} style={{ width: '300px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                                                {data.appname}
                                            </div>
                                            <div className="apiCloseIcon" onClick={(event) => {
                                                event.stopPropagation();
                                                setShowDeletePopup(!showDeletePopup); // Open the modal
                                                setAppInfo(data);
                                            }} >
                                                {/* <MDBIcon fas icon="times" size="lg" /> */}
                                                <MDBIcon fas icon="trash" size="lg" />
                                            </div>
                                        </MDBCardTitle>
                                        <MDBCardText>
                                            <p>Status: {data.status === 2 ? "Production" : "Development"}</p>
                                            <p className="mt-2">Client ID: {data.client_id}</p>
                                        </MDBCardText>
                                    </MDBCardBody>
                                </MDBCard>
                            </MDBCol>
                        ))}

                        {steamsAPIApssInfo.length === 0 && !loading && (
                            <MDBRow className="justify-content-center">
                                <div class="text-center">No records found</div>
                            </MDBRow>
                        )}

                    </MDBRow>
                )}
                {createAppModal && <CreateStreamsAPIApps open={createAppModal} setOpen={setCreateAppModal} toggle={toggleCreateAppModal} info={appInfo} />}
                {showDeletePopup && <ApiAppDeletePopup open={showDeletePopup} setOpen={setShowDeletePopup} info={appInfo} setLoader={setLoading} />}
            </>
        </React.Fragment>
    )
}
export default StreamsAPIApps
